import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/compliance/drata-vs-vanta/CtaLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/compliance/drata-vs-vanta/DrataLeadForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/video/VideoGallery.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
